export default __webpack_public_path__ + "static/media/sk8dog.8065c411.jpg";